export default __webpack_public_path__ + "static/media/Algo Signer.8d21cecd.png";